<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <vs-table
          :max-items="paginationItems[1]"
          pagination
          multiple
          v-model="selected"
          :data="vouchers"
          :description="false"
          search
          :reduce="(obj) => obj.id"
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("inventory.label.ManageVoucherPins") }}
            </div>
            <div class="mr-2 mt-1 order-1">
              <v-select
                label="label"
                v-model="filter"
                :options="['NEW', 'LOST', 'DAMAGE', 'USED']"
                :placeholder="$t('setup.label.Filter_List')"
                @input="filterList(filter)"
                class="min-w-200 w-full mb-2 table-header"
              >
                <template v-slot:option="option">{{ option.label }}</template>
              </v-select>
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-edit"
                @click="update()"
                size="small"
                >{{ $t("inventory.label.Update") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-trash"
                color="danger"
                type="border"
                @click="deletePopup = true"
                size="small"
                >{{ $t("inventory.label.Delete") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("inventory.label.BatchName") }}</vs-th>
            <vs-th>{{ $t("inventory.label.OfficeId") }}</vs-th>
            <vs-th>{{ $t("inventory.label.SerialNo") }}</vs-th>
            <vs-th>{{ $t("inventory.label.PinNo") }}</vs-th>
            <vs-th>{{ $t("inventory.label.CustomerId") }}</vs-th>
            <vs-th>{{ $t("inventory.label.PinType") }}</vs-th>
            <vs-th>{{ $t("inventory.label.Value") }}</vs-th>
            <vs-th>{{ $t("inventory.label.status") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="voucher"
              :is-selected="!!selected.includes(voucher)"
              v-for="(voucher, index) in data"
            >
              <vs-td :data="voucher.batchName">{{ voucher.batchName }}</vs-td>
              <vs-td :data="voucher.officeId">{{ voucher.officeId }}</vs-td>
              <vs-td :data="voucher.serialNo">{{ voucher.serialNo }}</vs-td>
              <vs-td :data="voucher.pinNo">{{ voucher.pinNo }}</vs-td>
              <vs-td :data="voucher.clientId">{{ voucher.clientId }}</vs-td>
              <vs-td :data="voucher.pinType">{{ voucher.pinType }}</vs-td>
              <vs-td :data="voucher.pinValue">{{
                voucher.pinType === "PRODUCT"
                  ? voucher.planCode
                  : voucher.pinValue
              }}</vs-td>
              <vs-td :data="voucher.status">{{ voucher.status }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>

      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.UpdateVoucher')"
          :active.sync="updatePopup"
          class="popup-close small-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="dropdown-with-label">
                  <small class="date-label">{{ $t("setup.label.UpdatePin") }}</small>
                  <v-select
                    label="adjustmentCode"
                    v-model="updateVoucher"
                    :options="['LOST', 'DAMAGE']"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  />
                </div>
              </div>
            </div>
            <div style="height: 20px"></div>
            <div class="center">
              <span class="p-2">
                <vs-button type="border" @click="updatePopup = false">{{
                  $t("inventory.label.Cancel")
                }}</vs-button></span
              >

              <span class="p-2">
                <vs-button @click="updateVouchers">{{
                  $t("inventory.label.Confirm")
                }}</vs-button>
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>

      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.DeleteVoucher')"
          :active.sync="deletePopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">{{$t("setup.label.Are_you_sure_you_want_to_delete_?")}}</div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deletePopup = false">{{
                $t("inventory.label.Cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="deleteVouchers">{{
                $t("inventory.label.Confirm")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import moment from "moment";
import VxCard from "@/components/vx-card/VxCard.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  components: { VxCard, "v-select": vSelect, AtomSpinner },
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      id: "",
      allCheck: false,
      selected: [],
      filter: "",
      updatePopup: false,
      updateVoucher: "",
      selectedIds: [],
      deletePopup: false,
      deleteImg: "@/assets/images/pages/delete.svg",
    };
  },
  computed: {
    ...mapState({
      vouchers: (state) => state.voucherPin.voucherPinList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getvoucherPinList() {
      this.loading = true;
      this.$store.dispatch("voucherPin/setVoucherPinList", this.id);
      this.loading = false;
    },
    update() {
      this.updatePopup = true;
    },
    async updateVouchers() {
      let payload = {
        id: this.id,
        data: { status: this.updateVoucher, voucherIds: this.selectedIds },
      };
      await this.$store.dispatch("voucherPin/updateVoucherPins", payload);
      this.getvoucherPinList();
      this.updatePopup = false;
    },
    async deleteVouchers() {
      let payload = {
        id: this.id,
        data: { voucherIds: this.selectedIds },
      };
      await this.$store.dispatch("voucherPin/deleteVoucherPins", payload);
      this.getvoucherPinList();
      this.deletePopup = false;
    },
    filterList() {
      if (this.filter != null) {
        this.$store.dispatch("voucherPin/setVoucherPinListWithStatus", {
          id: this.id,
          status: this.filter,
        });
      } else {
        this.getvoucherPinList();
      }
    },
    getDate(date) {
      if (date) {
        return moment(date).format(this.formattedDate);
      }
      return null;
    },
    process(id) {
      let payload = { voucherId: id };
      this.$store.dispatch("voucherPin/processVoucherAc", payload);
    },
  },
  watch: {
    selected(val) {
      this.selectedIds = [];
      for (let temp of val) {
        this.selectedIds.push(temp.id);
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getvoucherPinList();
  },
};
</script>
<style lang="scss">
.table-header .vs__selected-options {
  height: 32px !important;
}
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
